export default "__VITE_ASSET__DHKeUHVv__"